export function starsRating() {
    const ratingBlock = $(".rating:not(.rating-fill)");

    ratingBlock.each(function(i, item){
        let fill = $(item).find(".rating");
        let number = +$(item).attr("data-stars-number");
        let percent = (number / 5) * 100;
        
        if(number && typeof number === "number") {
            fill.css("width", number > 5 ? "100%" : percent + "%");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stars-rating.js